import React from 'react';

const AgendaFilterReset = ({AgendaOnReset, AgendaResetShow}) => (
	<p className="agenda-filter-reset"><button onClick={AgendaOnReset} rel="noopener noreferrer" className={ AgendaResetShow ? 'btn btn-primary btn-lg btn-pink-3 btn-show' : 'btn btn-primary btn-lg btn-pink-3 btn-hide' }>Réinitialiser les filtres</button></p>
)

export default AgendaFilterReset;
